"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to list finpro agents
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.statelist state list to display
 *
 * @returns {React.ReactElement} list of agents
 */
function StateList(props) {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled"
  }, (0, _lodash.map)(props.statelist, (state, stateIndex) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "h3",
      key: stateIndex
    }, (0, _lodash.isEmpty)(state.stateUrl) && /*#__PURE__*/_react.default.createElement("span", null, state.stateName, /*#__PURE__*/_react.default.createElement("sup", null, "**")), !(0, _lodash.isEmpty)(state.stateUrl) && /*#__PURE__*/_react.default.createElement("a", {
      className: "btn btn-inline",
      href: state.stateUrl
    }, state.stateName));
  })));
}
var _default = exports.default = StateList;